import { createSlice, createSelector } from '@reduxjs/toolkit'
import { HYDRATE } from 'next-redux-wrapper'
import { apiUrlClient, customerId } from '@/utils/env'

export const initialState = {
  isOnline: true,
  iframeDomain: null,
  specificDomain: null,
  isInFrame: null,
  isInApp: null,
  all: null,
  showStaticLogo: false,
  apiUrlClient,
  version: null,
  customerId
}

const configs = createSlice({
  name: 'configs',
  initialState,
  reducers: {
    SET_ALL: (state, { payload }) => {
      state.all = payload
    },
    SET_ONLINE_STATUS: (state, { payload }) => {
      state.isOnline = payload
    },
    SET_IFRAME_DOMAIN: (state, { payload }) => {
      state.iframeDomain = payload
    },
    SET_SPECIFIC_DOMAIN: (state, { payload }) => {
      state.specificDomain = payload
    },
    SET_IS_IN_IFRAME: (state, { payload }) => {
      state.isInFrame = payload
    },
    SET_IS_APP: (state, { payload }) => {
      state.isInApp = payload
    },
    SET_SHOW_STATIC_LOGO: (state, { payload }) => {
      state.showStaticLogo = payload
    },
    SET_API_URL_CLIENT: (state, { payload }) => {
      state.apiUrlClient = payload
    },
    SET_VERSION: (state, { payload }) => {
      state.version = payload
    }
  },
  extraReducers: builder => {
    builder.addCase(HYDRATE, (state, action) => {
      if (action.payload.configs) {
        state.all = action.payload.configs.all || state.all
        state.isInApp = action.payload.configs.isInApp || state.isInApp
        state.apiUrlClient = action.payload.configs.apiUrlClient || state.apiUrlClient
        state.version = state.version
        state.showStaticLogo = action.payload.configs.showStaticLogo || state.showStaticLogo
        state.customerId = action.payload.configs.customerId || state.customerId
      }
    })
  }
})

const selectAllConfigs = ({ configs }) => configs?.all || {}

export const selectConfigByKey = (key, defaultValue = {}) =>
  createSelector(selectAllConfigs, byKey => byKey[key] || defaultValue)

export const configsActions = configs.actions

export const configSelectors = {
  selectConfigs: ({ configs }) => configs,
  selectIsOnline: ({ configs }) => configs?.isOnline,
  selectIframeDomain: ({ configs }) => configs?.iframeDomain,
  selectSpecificDomain: ({ configs }) => configs?.specificDomain,
  selectIsInFrame: ({ configs }) => configs?.isInFrame,
  selectIsInApp: ({ configs }) => configs?.isInApp,
  selectVersion: ({ configs }) => configs?.version,
  selectApiUrlClient: ({ configs }) => configs?.apiUrlClient,
  selectCustomerId: ({ configs }) => configs?.customerId,
  selectAllConfigs,
  selectConfigByKey
}

export default configs
